<template>
  <div
    class="kq-container"
    :style="{
      backgroundColor: backgroundColor,
      borderLeft: isBorder ? '1px solid #cfd7e5' : 'none',
      borderRight: isBorder ? '1px solid #cfd7e5' : 'none'
    }"
  >
    <el-scrollbar
      v-if="type === 'scroll'"
      ref="KqScrollbarRef"
      class="kq-container-scroll scroll-hide-x"
      @scroll="callback"
    >
      <div class="kq-container-content" :style="{ margin: padding }">
        <slot />
      </div>
    </el-scrollbar>
    <div v-else-if="type === 'flex'" class="kq-container-flex flex-column" :style="{ padding: padding }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'KqContainer',
  props: {
    type: {
      type: String,
      default: 'flex'
    },
    backgroundColor: {
      type: String,
      default: '#fff'
    },
    isBorder: {
      type: Boolean,
      default: true
    },
    padding: {
      type: String,
      default: '20px'
    }
  },
  methods: {
    callback(e) {
      this.$emit('scroll', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.kq-container {
  @extend %full;
  overflow: hidden;

  .kq-container-scroll {
    width: 100%;
    height: 100%;
  }

  .kq-container-flex {
    width: 100%;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
  }
}
</style>
